import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Tooltip, Icon, Modal, Button } from "antd";
import { observable, action, computed } from "mobx";
import { observer } from "mobx-react";
import { TemplateModel } from "../../../../stores/TemplateModel";
import { MailBuilder } from "mail-builder-package";

interface Props extends RouteComponentProps<any> {
  template: TemplateModel;
}

@observer
class PreviewTemplateAction extends React.PureComponent<Props, any> {
  @observable templateForModal: TemplateModel | null = null;

  @computed get isModalVisible() {
    return this.templateForModal !== null;
  }
  @action setTemplateForModal = (template: TemplateModel) => {
    this.templateForModal = template;
  };
  @action closeModal = () => {
    this.templateForModal = null;
  };
  renderModalFooter = () => {
    return (
      <>
        <Button type="link" onClick={() => {}}>
          Edit
        </Button>
        <Button type="primary" onClick={this.closeModal}>
          Close
        </Button>
      </>
    );
  };

  render() {
    const { template } = this.props;
    return (
      <>
        <Tooltip placement="bottomRight" title={"Preview"}>
          <button onClick={() => this.setTemplateForModal(template)}>
            <Icon type="eye" />
          </button>
        </Tooltip>

        <Modal
          title={null}
          visible={this.isModalVisible}
          afterClose={this.closeModal}
          width={"95%"}
          style={{ height: "95%" }}
          centered={true}
          bodyStyle={{ height: "calc(100% - 55px)", padding: 0 }}
          cancelText={"Edit"}
          okText={"Close"}
          footer={this.renderModalFooter()}
          onCancel={this.closeModal}
        >
          {this.templateForModal && (
            <MailBuilder
              template={this.templateForModal!.json}
              imagePreviewMode
              topBar
            />
          )}
        </Modal>
      </>
    );
  }
}
export default withRouter(PreviewTemplateAction);
